import { Cpu, Fingerprint, HardDrive, Network } from "lucide-react";
import WooferDemo from "@/components/WooferDemo";

const identifiers = [
  { Icon: Fingerprint, label: "Motherboard Serial" },
  { Icon: Cpu, label: "CPU / GPU IDs" },
  { Icon: Network, label: "MAC Address" },
  { Icon: HardDrive, label: "Disk Signatures" },
];

const WooferBlock = () => {
  const goToWooferPlans = () => {
    window.dispatchEvent(new CustomEvent("scythe:show-woofer"));
  };

  return (
    <section data-testid="woofer-section" className="py-24 px-6 border-b border-red-500/20 relative overflow-hidden">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
        <div>
          <div className="flex items-center gap-2 font-mono-x text-xs text-[#ff4655] mb-4">
            <span className="w-2 h-2 bg-[#ff4655] blink-dot"></span>
            NEW PRODUCT LINE // HARDWARE UTILITY
          </div>
          <h2 className="font-display text-5xl md:text-6xl uppercase tracking-tighter leading-[0.9] text-white mb-6">
            Woofer — Hardware<br />
            <span className="text-[#ff4655]">Identity, Rewritten.</span>
          </h2>
          <p className="text-zinc-300 text-base md:text-lg leading-relaxed mb-8">
            Woofer is a hardware ID utility that rewrites and masks your machine's unique system
            identifiers, so your PC presents a completely fresh hardware profile.
          </p>
          <div className="flex flex-wrap items-center gap-4 mb-8">
            <span className="font-mono-x text-xs text-zinc-400 uppercase tracking-widest">
              One-Time <span className="text-white font-bold">€25</span>
            </span>
            <span className="text-zinc-700">/</span>
            <span className="font-mono-x text-xs text-zinc-400 uppercase tracking-widest">
              Lifetime <span className="text-[#ff4655] font-bold">€60</span>
            </span>
          </div>
          <a
            href="#pricing"
            onClick={goToWooferPlans}
            data-testid="woofer-cta-btn"
            className="inline-block px-8 py-4 bg-[#ff4655] hover:bg-white hover:text-black text-white font-extrabold uppercase text-xs tracking-widest transition-colors skew-x-[-8deg]"
          >
            <span className="inline-block skew-x-[8deg]">See Woofer Plans</span>
          </a>
        </div>

        <div className="p-6 bg-zinc-900/60 border border-zinc-800">
          <p className="font-mono-x text-[10px] uppercase tracking-widest text-[#ff4655] mb-5">
            Identifiers Woofer Rewrites
          </p>
          <div className="grid grid-cols-2 gap-4">
            {identifiers.map(({ Icon, label }) => (
              <div
                key={label}
                data-testid={`woofer-id-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="p-4 bg-[#0c0d12] border border-zinc-800 hover:border-[#ff4655]/50 transition-colors"
              >
                <Icon className="w-5 h-5 text-[#ff4655] mb-3" />
                <div className="text-white text-xs font-bold uppercase tracking-wider">{label}</div>
              </div>
            ))}
          </div>
          <p className="text-zinc-500 text-[10px] font-mono-x mt-5 leading-relaxed">
            Digital software only. Delivered via Discord after receipt verification.
          </p>
        </div>
      </div>

      <WooferDemo />
    </section>
  );
};

export default WooferBlock;
